import apiClient from "./config";

export const searchUsersForFriend = async (query) => {
  const { data } = await apiClient.get("/friends/search", {
    params: { query },
    withCredentials: true,
  });
  return data;
};

export const sendFriendRequest = async (targetUserId) => {
  const { data } = await apiClient.post(
    "/friends/request",
    { targetUserId },
    { withCredentials: true }
  );
  return data;
};

export const getIncomingFriendRequests = async () => {
  const { data } = await apiClient.get("/friends/requests/incoming", {
    withCredentials: true,
  });
  return data;
};

export const acceptFriendRequest = async (requestId) => {
  const { data } = await apiClient.post(
    `/friends/requests/${requestId}/accept`,
    {},
    { withCredentials: true }
  );
  return data;
};

export const getMyFriends = async () => {
  const { data } = await apiClient.get("/friends/my-friends", {
    withCredentials: true,
  });
  return data;
};